import React from "react";

export const ExportButton = props => (
	<button onClick={props.handleClick} className="list__item button">
		{props.buttonText}
	</button>
);
